import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Footer, Navbar, ScrollToTop } from '../../components';
import { routes } from '../../routes';
import './App.scss';

export const App = () => {
  return (
    <div className='app'>
      <Router>
        <ScrollToTop />
        <Navbar />
        <main className='container mb-5'>
          {routes.map(({ path, Page }) => (
            <Route key={path} exact path={path}>
              <Page />
            </Route>
          ))}
        </main>
        <Footer />
      </Router>
    </div>
  );
};
